import { CHECKOUT_LICENSE_STATUS_CHANGED_EVENT } from '~/components/legacy/CheckoutProjectLicenseConfigurator.jsx';

export function checkoutHasIncompleteProjectLicenses(root = document) {
  return Array.from(root.querySelectorAll('[data-checkout-license-status]'))
    .map((element) => element.dataset.checkoutLicenseStatus)
    .filter(Boolean)
    .some((status) => status !== 'completed');
}

export function syncCheckoutContinueButton(root = document) {
  const button = root.querySelector('[data-checkout-continue-button]');
  const hint = root.querySelector('[data-checkout-continue-hint]');

  if (!button) {
    return false;
  }

  const disabled = checkoutHasIncompleteProjectLicenses(root);

  button.disabled = disabled;
  button.classList.toggle('button--disabled', disabled);
  button.setAttribute('aria-disabled', String(disabled));

  if (hint) {
    hint.hidden = !disabled;
    hint.setAttribute('aria-hidden', String(!disabled));
  }

  return disabled;
}

export function initCheckoutContinueButtonGuard(root = document) {
  const button = root.querySelector('[data-checkout-continue-button]');

  if (!button || button.dataset.checkoutContinueGuardInitialized === 'true') {
    return null;
  }

  const handleStatusChange = () => {
    syncCheckoutContinueButton(root);
  };

  syncCheckoutContinueButton(root);
  window.addEventListener(CHECKOUT_LICENSE_STATUS_CHANGED_EVENT, handleStatusChange);
  button.dataset.checkoutContinueGuardInitialized = 'true';

  return () => {
    window.removeEventListener(CHECKOUT_LICENSE_STATUS_CHANGED_EVENT, handleStatusChange);
    delete button.dataset.checkoutContinueGuardInitialized;
  };
}

if (typeof document !== 'undefined') {
  const initialize = () => {
    initCheckoutContinueButtonGuard(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}
